module.exports = __webpack_public_path__ + "img/haier.f2dbc45e.jpg";